import {DataFetcher} from '@aboutyou/data-fetcher';
import {ContentPopperProps} from '@aboutyou/ui-components';
import React from 'react';
import {SponsoredProductPopupView} from './SponsoredProductPopupView';
import {useSponsoredProductPopup} from './utils/useSponsoredProductPopup';
import {useSponsoredProductRequest} from './utils/useSponsoredProductRequest';

interface SponsoredProductPopupProps {
  LayoutComponent: ContentPopperProps['LayoutComponent'];
}

export const SponsoredProductPopup: React.FC<SponsoredProductPopupProps> = ({
  LayoutComponent,
}) => {
  const {productId, promotionId} = useSponsoredProductPopup();
  if (!productId && !promotionId) {
    return null;
  }

  return (
    <Fetcher
      productId={productId}
      promotionId={promotionId}
      LayoutComponent={LayoutComponent}
    />
  );
};

const Fetcher: React.FC<
  SponsoredProductPopupProps & {
    productId?: number;
    promotionId?: string;
  }
> = props => (
  <DataFetcher
    request={useSponsoredProductRequest({
      productId: props.productId,
      promotionId: props.promotionId,
    })}
    View={SponsoredProductPopupView}
    Loading={() => null}
    Error={null}
    viewProps={props}
  />
);
